import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Brand from "@/components/Brand";

const NAV = [
  { to: "/school/students", label: "Students" },
  { to: "/school/assign-test", label: "Assign Test" },
  { to: "/school/reports", label: "Reports" },
  { to: "/school/analytics", label: "Analytics" },
];

export default function SchoolDashboard() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  function onLogout() {
    logout();
    navigate("/school/login", { replace: true });
  }

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-slate-50">
      <aside
        className="md:w-60 bg-white border-b md:border-b-0 md:border-r border-slate-200 flex md:flex-col"
        data-testid="school-sidebar"
      >
        <div className="px-5 py-4 md:py-5 border-r md:border-r-0 md:border-b border-slate-200 flex-shrink-0">
          <Brand size="sm" />
          <div className="text-[10px] uppercase tracking-[0.18em] text-indigo-700 mt-1">
            School Admin
          </div>
        </div>

        <nav className="flex-1 p-2 text-sm flex md:flex-col gap-1 overflow-x-auto md:overflow-x-visible">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`school-nav-${item.label
                .toLowerCase()
                .replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `block whitespace-nowrap rounded-md px-3 py-2 transition ${
                  isActive
                    ? "bg-indigo-50 text-indigo-800 font-medium"
                    : "text-slate-700 hover:bg-slate-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block border-t border-slate-200 p-3">
          <div
            className="text-xs text-slate-500 mb-2 truncate"
            data-testid="school-sidebar-user"
            title={admin?.email}
          >
            {admin?.email}
          </div>
          <button
            onClick={onLogout}
            data-testid="school-sidebar-logout"
            className="w-full rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-100"
          >
            Logout
          </button>
        </div>

        <div className="md:hidden flex items-center gap-2 px-3 border-l border-slate-200">
          <button
            onClick={onLogout}
            data-testid="school-sidebar-logout-mobile"
            className="rounded-md border border-slate-300 bg-white px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-100"
          >
            Logout
          </button>
        </div>
      </aside>

      <main className="flex-1 p-5 sm:p-8">
        <Outlet />
      </main>
    </div>
  );
}
